export const DELAY_BEFORE_REDIRECTION = 5000;
export const COOKIE_SESSION_EXTERNAL_CART_MODAL = 'shown_redirection_external_cart_modal';
